"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = exports.configDefaults = void 0;var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));function _interopRequireDefault(e) {return e && e.__esModule ? e : { default: e };}

var configDefaults = exports.configDefaults = {
  nui: {
    assets: {
      app: {
        useCDN: {
          value: false
        },
        path: {
          value: '/static'
        }
      },
      cdn: {
        url: {
          value: '//static.concursolutions.com'
        }
      }
    },
    DRCListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    jouleListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    log: {
      application: {
        value: 'appcenter-web',
        useDefault: true
      },
      roletype: {
        value: 'appc',
        useDefault: true
      },
      version: {
        value: '1.0.0',
        useDefault: true
      }
    },
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    categoryDropdownThreshold: {
      value: 20,
      clientExposed: true,
      useDefault: true
    },
    endorsedCategoryEnabled: {
      value: true,
      clientExposed: true,
      useDefault: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    },
    x509: {
      key: {
        value: '',
        useDefault: true
      },
      cert: {
        value: '',
        useDefault: true
      }
    },
    // NUI_ENABLEINCOMPLETEDNFCONNECTIONBLOCKING
    enableIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    // NUI_FORCEINCOMPLETEDNFCONNECTIONBLOCKING
    forceIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    disallowConnectList: {
      value: '',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://rqa3.nonprod.cnqr.tech',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  },
  cookie_consent: {
    value: false,
    useDefault: true,
    clientExposed: true
  }
};var _default = exports.default =

(0, _nuiConfig.default)(configDefaults);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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